export const weekdays = [
  {label: 'sunday', short_label: 'sun', value: 0, long_label: 'Sunday'},
  {label: 'monday', short_label: 'mon', value: 1, long_label: 'Monday'},
  {label: 'tuesday', short_label: 'tue', value: 2, long_label: 'Tuesday'},
  {label: 'wednesday', short_label: 'wed', value: 3, long_label: 'Wednesday'},
  {label: 'thursday', short_label: 'thu', value: 4, long_label: 'Thursday'},
  {label: 'friday', short_label: 'fri', value: 5, long_label: 'Friday'},
  {label: 'saturday', short_label: 'sat', value: 6, long_label: 'Saturday'},
]